import { Avatar } from '#/shared/ui/avatar'

interface OwnerCellProps {
  avatarUrl?: string
  name?: string
  status?: React.ReactNode
}

export function OwnerCell({ avatarUrl, name, status }: OwnerCellProps) {
  return (
    <div className="flex flex-col items-start">
      <div className="flex h-7 items-center gap-2.5">
        <Avatar
          size="sm"
          name={name ?? ''}
          src={avatarUrl}
          className="shrink-0 origin-center transition-transform duration-150 hover:scale-150"
        />
        {name && (
          <span
            title={name}
            className="max-w-28 truncate text-sm text-gray-900"
          >
            {name}
          </span>
        )}
      </div>
      {status && <div className="flex h-7 items-center">{status}</div>}
    </div>
  )
}
